import { Locale, Scope } from '@headless-workspace/config';
import { ServerErrorCode } from '@headless-workspace/data';
import { CommonDI, LoggerType } from '@headless-workspace/domain/common/DI';
import {
    getProductDetailInfo,
    PageManager,
    ProductDetailValue,
    RootPageManager,
    RootPageParams,
} from '@headless-workspace/domain/common/server';
import { getMemoNewsletterSlot } from '../newsletter';
import { getMemoReviewsWithSorting, RatingsAndReviewsValue } from './ratingsAndReviews';

type ProductDetailPageParams = Partial<{
    product: ProductDetailValue;
    reviews: RatingsAndReviewsValue;
}> &
    RootPageParams;

type ProductDetailPreloadParams = {
    locale: Locale;
    productId: string;
};

export const ProductDetailPageManager: PageManager<ProductDetailPageParams, ProductDetailPreloadParams> = {
    canGeneratePage({ product, reviews, ...rootParams }: ProductDetailPageParams): boolean {
        return RootPageManager.canGeneratePage(rootParams) && !!product && !!reviews;
    },

    preloadPageData({ locale, productId }: ProductDetailPreloadParams): void {
        Promise.allSettled([
            // All Product Detail Page preload functions should be added here
            getProductDetailInfo(locale, productId),
            getMemoReviewsWithSorting(locale, productId),
            getMemoNewsletterSlot(locale),
        ]).catch((error) => {
            CommonDI.get(LoggerType).error(ServerErrorCode.PagePreload, Scope.ProductDetailPage, error);
        });
    },
};
